import { Navigate, useParams } from 'react-router-dom'
import { resolveTarget } from '../lib/redirects'

/**
 * A redirect that carries its route parameters through.
 *
 * `<Navigate to="/cases/:alertId"/>` does not interpolate in react-router 7. It navigates to a path
 * containing a literal colon, which matches no route and falls through to the catch-all - so somebody
 * following a two-year-old link to an alert would land on the Board with no indication that anything
 * had been redirected at all.
 *
 * Three lines, and the only reason it is a component is that `useParams` is a hook.
 */
export function LegacyRedirect({ to }: { to: string }) {
  return <Navigate to={resolveTarget(to, useParams())} replace />
}
